var cov_3nd4b0rs3 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Datum/List.ts",
      hash = "5c5e58b609b9b0aa70cd8ca0ec978b5a9dd541a9",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Datum/List.ts",
    statementMap: {
      "0": {
        start: {
          line: 38,
          column: 90
        },
        end: {
          line: 38,
          column: 94
        }
      },
      "1": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 28
        }
      },
      "2": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 22
        }
      },
      "3": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 30
        }
      },
      "4": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 27
        }
      },
      "5": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 21
        }
      },
      "6": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 29
        }
      },
      "7": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 35
        }
      },
      "8": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 30
        }
      },
      "9": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 50,
          column: 48
        }
      },
      "10": {
        start: {
          line: 50,
          column: 20
        },
        end: {
          line: 50,
          column: 48
        }
      },
      "11": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 43
        }
      },
      "12": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 28
        }
      },
      "13": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 30
        }
      },
      "14": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 35
        }
      },
      "15": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 23
        }
      },
      "16": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 25
        }
      },
      "17": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 24
        }
      },
      "18": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 72,
          column: 31
        }
      },
      "19": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 75,
          column: 5
        }
      },
      "20": {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 74,
          column: 36
        }
      },
      "21": {
        start: {
          line: 79,
          column: 16
        },
        end: {
          line: 79,
          column: 25
        }
      },
      "22": {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 82,
          column: 5
        }
      },
      "23": {
        start: {
          line: 81,
          column: 6
        },
        end: {
          line: 81,
          column: 36
        }
      },
      "24": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 23
        }
      },
      "25": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 87,
          column: 49
        }
      },
      "26": {
        start: {
          line: 87,
          column: 43
        },
        end: {
          line: 87,
          column: 49
        }
      },
      "27": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 35
        }
      },
      "28": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 99,
          column: 5
        }
      },
      "29": {
        start: {
          line: 91,
          column: 6
        },
        end: {
          line: 98,
          column: 7
        }
      },
      "30": {
        start: {
          line: 93,
          column: 10
        },
        end: {
          line: 93,
          column: 25
        }
      },
      "31": {
        start: {
          line: 95,
          column: 10
        },
        end: {
          line: 95,
          column: 39
        }
      },
      "32": {
        start: {
          line: 97,
          column: 10
        },
        end: {
          line: 97,
          column: 22
        }
      },
      "33": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 103,
          column: 25
        }
      },
      "34": {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 104,
          column: 24
        }
      },
      "35": {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 105,
          column: 31
        }
      },
      "36": {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 108,
          column: 5
        }
      },
      "37": {
        start: {
          line: 107,
          column: 6
        },
        end: {
          line: 107,
          column: 45
        }
      },
      "38": {
        start: {
          line: 112,
          column: 17
        },
        end: {
          line: 112,
          column: 104
        }
      },
      "39": {
        start: {
          line: 112,
          column: 31
        },
        end: {
          line: 112,
          column: 45
        }
      },
      "40": {
        start: {
          line: 112,
          column: 57
        },
        end: {
          line: 112,
          column: 102
        }
      },
      "41": {
        start: {
          line: 113,
          column: 16
        },
        end: {
          line: 113,
          column: 27
        }
      },
      "42": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 117,
          column: 5
        }
      },
      "43": {
        start: {
          line: 115,
          column: 21
        },
        end: {
          line: 115,
          column: 49
        }
      },
      "44": {
        start: {
          line: 116,
          column: 6
        },
        end: {
          line: 116,
          column: 31
        }
      },
      "45": {
        start: {
          line: 116,
          column: 18
        },
        end: {
          line: 116,
          column: 31
        }
      },
      "46": {
        start: {
          line: 118,
          column: 28
        },
        end: {
          line: 118,
          column: 30
        }
      },
      "47": {
        start: {
          line: 119,
          column: 20
        },
        end: {
          line: 127,
          column: 5
        }
      },
      "48": {
        start: {
          line: 120,
          column: 6
        },
        end: {
          line: 126,
          column: 8
        }
      },
      "49": {
        start: {
          line: 121,
          column: 22
        },
        end: {
          line: 123,
          column: 9
        }
      },
      "50": {
        start: {
          line: 122,
          column: 10
        },
        end: {
          line: 122,
          column: 102
        }
      },
      "51": {
        start: {
          line: 124,
          column: 8
        },
        end: {
          line: 124,
          column: 38
        }
      },
      "52": {
        start: {
          line: 124,
          column: 20
        },
        end: {
          line: 124,
          column: 38
        }
      },
      "53": {
        start: {
          line: 125,
          column: 8
        },
        end: {
          line: 125,
          column: 80
        }
      },
      "54": {
        start: {
          line: 125,
          column: 31
        },
        end: {
          line: 125,
          column: 80
        }
      },
      "55": {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 128,
          column: 17
        }
      },
      "56": {
        start: {
          line: 129,
          column: 4
        },
        end: {
          line: 129,
          column: 58
        }
      },
      "57": {
        start: {
          line: 129,
          column: 21
        },
        end: {
          line: 129,
          column: 58
        }
      },
      "58": {
        start: {
          line: 130,
          column: 4
        },
        end: {
          line: 130,
          column: 18
        }
      },
      "59": {
        start: {
          line: 134,
          column: 4
        },
        end: {
          line: 134,
          column: 26
        }
      },
      "60": {
        start: {
          line: 138,
          column: 4
        },
        end: {
          line: 138,
          column: 51
        }
      },
      "61": {
        start: {
          line: 138,
          column: 45
        },
        end: {
          line: 138,
          column: 51
        }
      },
      "62": {
        start: {
          line: 141,
          column: 4
        },
        end: {
          line: 141,
          column: 43
        }
      },
      "63": {
        start: {
          line: 141,
          column: 26
        },
        end: {
          line: 141,
          column: 43
        }
      },
      "64": {
        start: {
          line: 142,
          column: 4
        },
        end: {
          line: 142,
          column: 24
        }
      },
      "65": {
        start: {
          line: 144,
          column: 15
        },
        end: {
          line: 144,
          column: 50
        }
      },
      "66": {
        start: {
          line: 145,
          column: 4
        },
        end: {
          line: 147,
          column: 5
        }
      },
      "67": {
        start: {
          line: 146,
          column: 6
        },
        end: {
          line: 146,
          column: 52
        }
      },
      "68": {
        start: {
          line: 148,
          column: 4
        },
        end: {
          line: 153,
          column: 6
        }
      },
      "69": {
        start: {
          line: 149,
          column: 23
        },
        end: {
          line: 149,
          column: 39
        }
      },
      "70": {
        start: {
          line: 150,
          column: 6
        },
        end: {
          line: 150,
          column: 32
        }
      },
      "71": {
        start: {
          line: 150,
          column: 20
        },
        end: {
          line: 150,
          column: 32
        }
      },
      "72": {
        start: {
          line: 151,
          column: 6
        },
        end: {
          line: 151,
          column: 46
        }
      },
      "73": {
        start: {
          line: 151,
          column: 25
        },
        end: {
          line: 151,
          column: 46
        }
      },
      "74": {
        start: {
          line: 152,
          column: 6
        },
        end: {
          line: 152,
          column: 17
        }
      },
      "75": {
        start: {
          line: 155,
          column: 19
        },
        end: {
          line: 155,
          column: 21
        }
      },
      "76": {
        start: {
          line: 156,
          column: 4
        },
        end: {
          line: 159,
          column: 5
        }
      },
      "77": {
        start: {
          line: 157,
          column: 16
        },
        end: {
          line: 157,
          column: 30
        }
      },
      "78": {
        start: {
          line: 158,
          column: 6
        },
        end: {
          line: 158,
          column: 41
        }
      },
      "79": {
        start: {
          line: 158,
          column: 27
        },
        end: {
          line: 158,
          column: 41
        }
      },
      "80": {
        start: {
          line: 161,
          column: 4
        },
        end: {
          line: 161,
          column: 100
        }
      },
      "81": {
        start: {
          line: 165,
          column: 4
        },
        end: {
          line: 165,
          column: 21
        }
      },
      "82": {
        start: {
          line: 166,
          column: 4
        },
        end: {
          line: 166,
          column: 24
        }
      },
      "83": {
        start: {
          line: 167,
          column: 4
        },
        end: {
          line: 167,
          column: 19
        }
      },
      "84": {
        start: {
          line: 171,
          column: 4
        },
        end: {
          line: 176,
          column: 5
        }
      },
      "85": {
        start: {
          line: 172,
          column: 6
        },
        end: {
          line: 174,
          column: 7
        }
      },
      "86": {
        start: {
          line: 173,
          column: 8
        },
        end: {
          line: 173,
          column: 61
        }
      },
      "87": {
        start: {
          line: 173,
          column: 50
        },
        end: {
          line: 173,
          column: 61
        }
      },
      "88": {
        start: {
          line: 175,
          column: 6
        },
        end: {
          line: 175,
          column: 18
        }
      },
      "89": {
        start: {
          line: 177,
          column: 4
        },
        end: {
          line: 177,
          column: 48
        }
      },
      "90": {
        start: {
          line: 181,
          column: 4
        },
        end: {
          line: 186,
          column: 5
        }
      },
      "91": {
        start: {
          line: 182,
          column: 6
        },
        end: {
          line: 184,
          column: 7
        }
      },
      "92": {
        start: {
          line: 183,
          column: 8
        },
        end: {
          line: 183,
          column: 59
        }
      },
      "93": {
        start: {
          line: 183,
          column: 45
        },
        end: {
          line: 183,
          column: 59
        }
      },
      "94": {
        start: {
          line: 185,
          column: 6
        },
        end: {
          line: 185,
          column: 17
        }
      },
      "95": {
        start: {
          line: 187,
          column: 4
        },
        end: {
          line: 187,
          column: 51
        }
      },
      "96": {
        start: {
          line: 187,
          column: 26
        },
        end: {
          line: 187,
          column: 50
        }
      },
      "97": {
        start: {
          line: 191,
          column: 4
        },
        end: {
          line: 191,
          column: 20
        }
      },
      "98": {
        start: {
          line: 195,
          column: 18
        },
        end: {
          line: 195,
          column: 36
        }
      },
      "99": {
        start: {
          line: 196,
          column: 4
        },
        end: {
          line: 196,
          column: 22
        }
      },
      "100": {
        start: {
          line: 196,
          column: 16
        },
        end: {
          line: 196,
          column: 22
        }
      },
      "101": {
        start: {
          line: 197,
          column: 4
        },
        end: {
          line: 197,
          column: 36
        }
      },
      "102": {
        start: {
          line: 197,
          column: 24
        },
        end: {
          line: 197,
          column: 35
        }
      },
      "103": {
        start: {
          line: 201,
          column: 4
        },
        end: {
          line: 211,
          column: 5
        }
      },
      "104": {
        start: {
          line: 203,
          column: 8
        },
        end: {
          line: 203,
          column: 39
        }
      },
      "105": {
        start: {
          line: 203,
          column: 31
        },
        end: {
          line: 203,
          column: 39
        }
      },
      "106": {
        start: {
          line: 204,
          column: 8
        },
        end: {
          line: 204,
          column: 13
        }
      },
      "107": {
        start: {
          line: 206,
          column: 8
        },
        end: {
          line: 206,
          column: 39
        }
      },
      "108": {
        start: {
          line: 206,
          column: 31
        },
        end: {
          line: 206,
          column: 39
        }
      },
      "109": {
        start: {
          line: 207,
          column: 8
        },
        end: {
          line: 207,
          column: 13
        }
      },
      "110": {
        start: {
          line: 209,
          column: 8
        },
        end: {
          line: 209,
          column: 28
        }
      },
      "111": {
        start: {
          line: 209,
          column: 27
        },
        end: {
          line: 209,
          column: 28
        }
      },
      "112": {
        start: {
          line: 210,
          column: 8
        },
        end: {
          line: 210,
          column: 13
        }
      },
      "113": {
        start: {
          line: 215,
          column: 4
        },
        end: {
          line: 215,
          column: 38
        }
      },
      "114": {
        start: {
          line: 219,
          column: 4
        },
        end: {
          line: 219,
          column: 53
        }
      },
      "115": {
        start: {
          line: 219,
          column: 47
        },
        end: {
          line: 219,
          column: 53
        }
      },
      "116": {
        start: {
          line: 221,
          column: 20
        },
        end: {
          line: 221,
          column: 58
        }
      },
      "117": {
        start: {
          line: 222,
          column: 4
        },
        end: {
          line: 224,
          column: 5
        }
      },
      "118": {
        start: {
          line: 223,
          column: 6
        },
        end: {
          line: 223,
          column: 59
        }
      },
      "119": {
        start: {
          line: 225,
          column: 4
        },
        end: {
          line: 225,
          column: 53
        }
      },
      "120": {
        start: {
          line: 225,
          column: 35
        },
        end: {
          line: 225,
          column: 52
        }
      },
      "121": {
        start: {
          line: 226,
          column: 19
        },
        end: {
          line: 226,
          column: 21
        }
      },
      "122": {
        start: {
          line: 228,
          column: 4
        },
        end: {
          line: 254,
          column: 5
        }
      },
      "123": {
        start: {
          line: 229,
          column: 26
        },
        end: {
          line: 229,
          column: 35
        }
      },
      "124": {
        start: {
          line: 230,
          column: 6
        },
        end: {
          line: 236,
          column: 7
        }
      },
      "125": {
        start: {
          line: 231,
          column: 8
        },
        end: {
          line: 235,
          column: 9
        }
      },
      "126": {
        start: {
          line: 232,
          column: 10
        },
        end: {
          line: 232,
          column: 46
        }
      },
      "127": {
        start: {
          line: 234,
          column: 10
        },
        end: {
          line: 234,
          column: 53
        }
      },
      "128": {
        start: {
          line: 237,
          column: 6
        },
        end: {
          line: 242,
          column: 7
        }
      },
      "129": {
        start: {
          line: 238,
          column: 20
        },
        end: {
          line: 238,
          column: 34
        }
      },
      "130": {
        start: {
          line: 239,
          column: 8
        },
        end: {
          line: 241,
          column: 9
        }
      },
      "131": {
        start: {
          line: 240,
          column: 10
        },
        end: {
          line: 240,
          column: 26
        }
      },
      "132": {
        start: {
          line: 244,
          column: 29
        },
        end: {
          line: 244,
          column: 33
        }
      },
      "133": {
        start: {
          line: 245,
          column: 6
        },
        end: {
          line: 253,
          column: 7
        }
      },
      "134": {
        start: {
          line: 245,
          column: 13
        },
        end: {
          line: 253,
          column: 7
        }
      },
      "135": {
        start: {
          line: 246,
          column: 8
        },
        end: {
          line: 251,
          column: 9
        }
      },
      "136": {
        start: {
          line: 247,
          column: 10
        },
        end: {
          line: 250,
          column: 11
        }
      },
      "137": {
        start: {
          line: 248,
          column: 12
        },
        end: {
          line: 248,
          column: 29
        }
      },
      "138": {
        start: {
          line: 249,
          column: 12
        },
        end: {
          line: 249,
          column: 26
        }
      },
      "139": {
        start: {
          line: 252,
          column: 8
        },
        end: {
          line: 252,
          column: 24
        }
      },
      "140": {
        start: {
          line: 257,
          column: 4
        },
        end: {
          line: 257,
          column: 43
        }
      },
      "141": {
        start: {
          line: 261,
          column: 4
        },
        end: {
          line: 261,
          column: 52
        }
      },
      "142": {
        start: {
          line: 261,
          column: 29
        },
        end: {
          line: 261,
          column: 52
        }
      },
      "143": {
        start: {
          line: 262,
          column: 19
        },
        end: {
          line: 262,
          column: 37
        }
      },
      "144": {
        start: {
          line: 263,
          column: 4
        },
        end: {
          line: 263,
          column: 35
        }
      },
      "145": {
        start: {
          line: 263,
          column: 29
        },
        end: {
          line: 263,
          column: 35
        }
      },
      "146": {
        start: {
          line: 264,
          column: 4
        },
        end: {
          line: 264,
          column: 19
        }
      },
      "147": {
        start: {
          line: 268,
          column: 4
        },
        end: {
          line: 268,
          column: 35
        }
      },
      "148": {
        start: {
          line: 268,
          column: 29
        },
        end: {
          line: 268,
          column: 35
        }
      },
      "149": {
        start: {
          line: 269,
          column: 4
        },
        end: {
          line: 269,
          column: 65
        }
      },
      "150": {
        start: {
          line: 269,
          column: 56
        },
        end: {
          line: 269,
          column: 64
        }
      },
      "151": {
        start: {
          line: 273,
          column: 21
        },
        end: {
          line: 273,
          column: 32
        }
      },
      "152": {
        start: {
          line: 275,
          column: 4
        },
        end: {
          line: 276,
          column: 69
        }
      },
      "153": {
        start: {
          line: 275,
          column: 26
        },
        end: {
          line: 275,
          column: 48
        }
      },
      "154": {
        start: {
          line: 276,
          column: 9
        },
        end: {
          line: 276,
          column: 69
        }
      },
      "155": {
        start: {
          line: 276,
          column: 29
        },
        end: {
          line: 276,
          column: 69
        }
      },
      "156": {
        start: {
          line: 277,
          column: 4
        },
        end: {
          line: 277,
          column: 29
        }
      },
      "157": {
        start: {
          line: 278,
          column: 4
        },
        end: {
          line: 278,
          column: 16
        }
      },
      "158": {
        start: {
          line: 282,
          column: 4
        },
        end: {
          line: 282,
          column: 25
        }
      },
      "159": {
        start: {
          line: 283,
          column: 4
        },
        end: {
          line: 283,
          column: 24
        }
      },
      "160": {
        start: {
          line: 284,
          column: 4
        },
        end: {
          line: 286,
          column: 5
        }
      },
      "161": {
        start: {
          line: 285,
          column: 6
        },
        end: {
          line: 285,
          column: 36
        }
      },
      "162": {
        start: {
          line: 287,
          column: 4
        },
        end: {
          line: 287,
          column: 31
        }
      },
      "163": {
        start: {
          line: 288,
          column: 4
        },
        end: {
          line: 288,
          column: 30
        }
      },
      "164": {
        start: {
          line: 292,
          column: 4
        },
        end: {
          line: 294,
          column: 5
        }
      },
      "165": {
        start: {
          line: 293,
          column: 6
        },
        end: {
          line: 293,
          column: 21
        }
      },
      "166": {
        start: {
          line: 296,
          column: 4
        },
        end: {
          line: 296,
          column: 26
        }
      },
      "167": {
        start: {
          line: 296,
          column: 17
        },
        end: {
          line: 296,
          column: 26
        }
      },
      "168": {
        start: {
          line: 298,
          column: 4
        },
        end: {
          line: 300,
          column: 5
        }
      },
      "169": {
        start: {
          line: 299,
          column: 6
        },
        end: {
          line: 299,
          column: 19
        }
      },
      "170": {
        start: {
          line: 302,
          column: 4
        },
        end: {
          line: 309,
          column: 5
        }
      },
      "171": {
        start: {
          line: 303,
          column: 6
        },
        end: {
          line: 305,
          column: 7
        }
      },
      "172": {
        start: {
          line: 304,
          column: 8
        },
        end: {
          line: 304,
          column: 62
        }
      },
      "173": {
        start: {
          line: 304,
          column: 53
        },
        end: {
          line: 304,
          column: 61
        }
      },
      "174": {
        start: {
          line: 307,
          column: 6
        },
        end: {
          line: 307,
          column: 58
        }
      },
      "175": {
        start: {
          line: 308,
          column: 6
        },
        end: {
          line: 308,
          column: 21
        }
      },
      "176": {
        start: {
          line: 311,
          column: 4
        },
        end: {
          line: 311,
          column: 59
        }
      },
      "177": {
        start: {
          line: 312,
          column: 4
        },
        end: {
          line: 312,
          column: 13
        }
      },
      "178": {
        start: {
          line: 316,
          column: 4
        },
        end: {
          line: 316,
          column: 47
        }
      },
      "179": {
        start: {
          line: 316,
          column: 41
        },
        end: {
          line: 316,
          column: 47
        }
      },
      "180": {
        start: {
          line: 317,
          column: 4
        },
        end: {
          line: 322,
          column: 5
        }
      },
      "181": {
        start: {
          line: 318,
          column: 6
        },
        end: {
          line: 318,
          column: 45
        }
      },
      "182": {
        start: {
          line: 319,
          column: 6
        },
        end: {
          line: 319,
          column: 26
        }
      },
      "183": {
        start: {
          line: 321,
          column: 6
        },
        end: {
          line: 321,
          column: 92
        }
      },
      "184": {
        start: {
          line: 323,
          column: 4
        },
        end: {
          line: 323,
          column: 39
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        loc: {
          start: {
            line: 37,
            column: 56
          },
          end: {
            line: 54,
            column: 3
          }
        },
        line: 37
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 56,
            column: 3
          }
        },
        loc: {
          start: {
            line: 56,
            column: 15
          },
          end: {
            line: 58,
            column: 3
          }
        },
        line: 56
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 61,
            column: 2
          },
          end: {
            line: 61,
            column: 3
          }
        },
        loc: {
          start: {
            line: 61,
            column: 19
          },
          end: {
            line: 63,
            column: 3
          }
        },
        line: 61
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 65,
            column: 2
          },
          end: {
            line: 65,
            column: 3
          }
        },
        loc: {
          start: {
            line: 65,
            column: 15
          },
          end: {
            line: 67,
            column: 3
          }
        },
        line: 65
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 69,
            column: 2
          },
          end: {
            line: 69,
            column: 3
          }
        },
        loc: {
          start: {
            line: 69,
            column: 21
          },
          end: {
            line: 76,
            column: 3
          }
        },
        line: 69
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 78,
            column: 2
          },
          end: {
            line: 78,
            column: 3
          }
        },
        loc: {
          start: {
            line: 78,
            column: 18
          },
          end: {
            line: 84,
            column: 3
          }
        },
        line: 78
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 86,
            column: 2
          },
          end: {
            line: 86,
            column: 3
          }
        },
        loc: {
          start: {
            line: 86,
            column: 67
          },
          end: {
            line: 100,
            column: 3
          }
        },
        line: 86
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 90,
            column: 20
          },
          end: {
            line: 90,
            column: 21
          }
        },
        loc: {
          start: {
            line: 90,
            column: 44
          },
          end: {
            line: 99,
            column: 5
          }
        },
        line: 90
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 102,
            column: 2
          },
          end: {
            line: 102,
            column: 3
          }
        },
        loc: {
          start: {
            line: 102,
            column: 44
          },
          end: {
            line: 109,
            column: 3
          }
        },
        line: 102
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 111,
            column: 2
          },
          end: {
            line: 111,
            column: 3
          }
        },
        loc: {
          start: {
            line: 111,
            column: 57
          },
          end: {
            line: 131,
            column: 3
          }
        },
        line: 111
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 112,
            column: 26
          },
          end: {
            line: 112,
            column: 27
          }
        },
        loc: {
          start: {
            line: 112,
            column: 31
          },
          end: {
            line: 112,
            column: 45
          }
        },
        line: 112
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 112,
            column: 51
          },
          end: {
            line: 112,
            column: 52
          }
        },
        loc: {
          start: {
            line: 112,
            column: 57
          },
          end: {
            line: 112,
            column: 102
          }
        },
        line: 112
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 119,
            column: 20
          },
          end: {
            line: 119,
            column: 21
          }
        },
        loc: {
          start: {
            line: 119,
            column: 39
          },
          end: {
            line: 127,
            column: 5
          }
        },
        line: 119
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 120,
            column: 20
          },
          end: {
            line: 120,
            column: 21
          }
        },
        loc: {
          start: {
            line: 120,
            column: 28
          },
          end: {
            line: 126,
            column: 7
          }
        },
        line: 120
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 121,
            column: 35
          },
          end: {
            line: 121,
            column: 36
          }
        },
        loc: {
          start: {
            line: 122,
            column: 10
          },
          end: {
            line: 122,
            column: 102
          }
        },
        line: 122
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 133,
            column: 2
          },
          end: {
            line: 133,
            column: 3
          }
        },
        loc: {
          start: {
            line: 133,
            column: 25
          },
          end: {
            line: 135,
            column: 3
          }
        },
        line: 133
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 137,
            column: 2
          },
          end: {
            line: 137,
            column: 3
          }
        },
        loc: {
          start: {
            line: 137,
            column: 81
          },
          end: {
            line: 162,
            column: 3
          }
        },
        line: 137
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 148,
            column: 23
          },
          end: {
            line: 148,
            column: 24
          }
        },
        loc: {
          start: {
            line: 148,
            column: 28
          },
          end: {
            line: 153,
            column: 5
          }
        },
        line: 148
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 164,
            column: 2
          },
          end: {
            line: 164,
            column: 3
          }
        },
        loc: {
          start: {
            line: 164,
            column: 19
          },
          end: {
            line: 168,
            column: 3
          }
        },
        line: 164
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 170,
            column: 2
          },
          end: {
            line: 170,
            column: 3
          }
        },
        loc: {
          start: {
            line: 170,
            column: 19
          },
          end: {
            line: 178,
            column: 3
          }
        },
        line: 170
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 180,
            column: 2
          },
          end: {
            line: 180,
            column: 3
          }
        },
        loc: {
          start: {
            line: 180,
            column: 77
          },
          end: {
            line: 188,
            column: 3
          }
        },
        line: 180
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 187,
            column: 21
          },
          end: {
            line: 187,
            column: 22
          }
        },
        loc: {
          start: {
            line: 187,
            column: 26
          },
          end: {
            line: 187,
            column: 50
          }
        },
        line: 187
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 190,
            column: 2
          },
          end: {
            line: 190,
            column: 3
          }
        },
        loc: {
          start: {
            line: 190,
            column: 10
          },
          end: {
            line: 192,
            column: 3
          }
        },
        line: 190
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 194,
            column: 2
          },
          end: {
            line: 194,
            column: 3
          }
        },
        loc: {
          start: {
            line: 194,
            column: 39
          },
          end: {
            line: 198,
            column: 3
          }
        },
        line: 194
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 197,
            column: 18
          },
          end: {
            line: 197,
            column: 19
          }
        },
        loc: {
          start: {
            line: 197,
            column: 24
          },
          end: {
            line: 197,
            column: 35
          }
        },
        line: 197
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 200,
            column: 2
          },
          end: {
            line: 200,
            column: 3
          }
        },
        loc: {
          start: {
            line: 200,
            column: 57
          },
          end: {
            line: 212,
            column: 3
          }
        },
        line: 200
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 203,
            column: 22
          },
          end: {
            line: 203,
            column: 23
          }
        },
        loc: {
          start: {
            line: 203,
            column: 31
          },
          end: {
            line: 203,
            column: 39
          }
        },
        line: 203
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 206,
            column: 22
          },
          end: {
            line: 206,
            column: 23
          }
        },
        loc: {
          start: {
            line: 206,
            column: 31
          },
          end: {
            line: 206,
            column: 39
          }
        },
        line: 206
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 209,
            column: 22
          },
          end: {
            line: 209,
            column: 23
          }
        },
        loc: {
          start: {
            line: 209,
            column: 27
          },
          end: {
            line: 209,
            column: 28
          }
        },
        line: 209
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 214,
            column: 2
          },
          end: {
            line: 214,
            column: 3
          }
        },
        loc: {
          start: {
            line: 214,
            column: 48
          },
          end: {
            line: 216,
            column: 3
          }
        },
        line: 214
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 218,
            column: 2
          },
          end: {
            line: 218,
            column: 3
          }
        },
        loc: {
          start: {
            line: 218,
            column: 114
          },
          end: {
            line: 258,
            column: 3
          }
        },
        line: 218
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 225,
            column: 23
          },
          end: {
            line: 225,
            column: 24
          }
        },
        loc: {
          start: {
            line: 225,
            column: 35
          },
          end: {
            line: 225,
            column: 52
          }
        },
        line: 225
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 260,
            column: 2
          },
          end: {
            line: 260,
            column: 3
          }
        },
        loc: {
          start: {
            line: 260,
            column: 40
          },
          end: {
            line: 265,
            column: 3
          }
        },
        line: 260
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 267,
            column: 2
          },
          end: {
            line: 267,
            column: 3
          }
        },
        loc: {
          start: {
            line: 267,
            column: 42
          },
          end: {
            line: 270,
            column: 3
          }
        },
        line: 267
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 269,
            column: 51
          },
          end: {
            line: 269,
            column: 52
          }
        },
        loc: {
          start: {
            line: 269,
            column: 56
          },
          end: {
            line: 269,
            column: 64
          }
        },
        line: 269
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 272,
            column: 2
          },
          end: {
            line: 272,
            column: 3
          }
        },
        loc: {
          start: {
            line: 272,
            column: 13
          },
          end: {
            line: 279,
            column: 3
          }
        },
        line: 272
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 281,
            column: 2
          },
          end: {
            line: 281,
            column: 3
          }
        },
        loc: {
          start: {
            line: 281,
            column: 45
          },
          end: {
            line: 289,
            column: 3
          }
        },
        line: 281
      },
      "37": {
        name: "(anonymous_37)",
        decl: {
          start: {
            line: 291,
            column: 2
          },
          end: {
            line: 291,
            column: 3
          }
        },
        loc: {
          start: {
            line: 291,
            column: 41
          },
          end: {
            line: 313,
            column: 3
          }
        },
        line: 291
      },
      "38": {
        name: "(anonymous_38)",
        decl: {
          start: {
            line: 304,
            column: 48
          },
          end: {
            line: 304,
            column: 49
          }
        },
        loc: {
          start: {
            line: 304,
            column: 53
          },
          end: {
            line: 304,
            column: 61
          }
        },
        line: 304
      },
      "39": {
        name: "(anonymous_39)",
        decl: {
          start: {
            line: 315,
            column: 2
          },
          end: {
            line: 315,
            column: 3
          }
        },
        loc: {
          start: {
            line: 315,
            column: 72
          },
          end: {
            line: 324,
            column: 3
          }
        },
        line: 315
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 37,
            column: 14
          },
          end: {
            line: 37,
            column: 54
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 37,
            column: 52
          },
          end: {
            line: 37,
            column: 54
          }
        }],
        line: 37
      },
      "1": {
        loc: {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 50,
            column: 48
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 50,
            column: 48
          }
        }, {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 50,
            column: 48
          }
        }],
        line: 50
      },
      "2": {
        loc: {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        }, {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        }],
        line: 73
      },
      "3": {
        loc: {
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 87,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 87,
            column: 49
          }
        }, {
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 87,
            column: 49
          }
        }],
        line: 87
      },
      "4": {
        loc: {
          start: {
            line: 91,
            column: 6
          },
          end: {
            line: 98,
            column: 7
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 93,
            column: 25
          }
        }, {
          start: {
            line: 94,
            column: 8
          },
          end: {
            line: 95,
            column: 39
          }
        }, {
          start: {
            line: 96,
            column: 8
          },
          end: {
            line: 97,
            column: 22
          }
        }],
        line: 91
      },
      "5": {
        loc: {
          start: {
            line: 106,
            column: 4
          },
          end: {
            line: 108,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 106,
            column: 4
          },
          end: {
            line: 108,
            column: 5
          }
        }, {
          start: {
            line: 106,
            column: 4
          },
          end: {
            line: 108,
            column: 5
          }
        }],
        line: 106
      },
      "6": {
        loc: {
          start: {
            line: 112,
            column: 57
          },
          end: {
            line: 112,
            column: 102
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 112,
            column: 81
          },
          end: {
            line: 112,
            column: 98
          }
        }, {
          start: {
            line: 112,
            column: 101
          },
          end: {
            line: 112,
            column: 102
          }
        }],
        line: 112
      },
      "7": {
        loc: {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 117,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 117,
            column: 5
          }
        }, {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 117,
            column: 5
          }
        }],
        line: 114
      },
      "8": {
        loc: {
          start: {
            line: 116,
            column: 6
          },
          end: {
            line: 116,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 116,
            column: 6
          },
          end: {
            line: 116,
            column: 31
          }
        }, {
          start: {
            line: 116,
            column: 6
          },
          end: {
            line: 116,
            column: 31
          }
        }],
        line: 116
      },
      "9": {
        loc: {
          start: {
            line: 122,
            column: 10
          },
          end: {
            line: 122,
            column: 102
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 122,
            column: 28
          },
          end: {
            line: 122,
            column: 61
          }
        }, {
          start: {
            line: 122,
            column: 64
          },
          end: {
            line: 122,
            column: 102
          }
        }],
        line: 122
      },
      "10": {
        loc: {
          start: {
            line: 124,
            column: 8
          },
          end: {
            line: 124,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 124,
            column: 8
          },
          end: {
            line: 124,
            column: 38
          }
        }, {
          start: {
            line: 124,
            column: 8
          },
          end: {
            line: 124,
            column: 38
          }
        }],
        line: 124
      },
      "11": {
        loc: {
          start: {
            line: 125,
            column: 8
          },
          end: {
            line: 125,
            column: 80
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 125,
            column: 8
          },
          end: {
            line: 125,
            column: 80
          }
        }, {
          start: {
            line: 125,
            column: 8
          },
          end: {
            line: 125,
            column: 80
          }
        }],
        line: 125
      },
      "12": {
        loc: {
          start: {
            line: 129,
            column: 4
          },
          end: {
            line: 129,
            column: 58
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 129,
            column: 4
          },
          end: {
            line: 129,
            column: 58
          }
        }, {
          start: {
            line: 129,
            column: 4
          },
          end: {
            line: 129,
            column: 58
          }
        }],
        line: 129
      },
      "13": {
        loc: {
          start: {
            line: 138,
            column: 4
          },
          end: {
            line: 138,
            column: 51
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 138,
            column: 4
          },
          end: {
            line: 138,
            column: 51
          }
        }, {
          start: {
            line: 138,
            column: 4
          },
          end: {
            line: 138,
            column: 51
          }
        }],
        line: 138
      },
      "14": {
        loc: {
          start: {
            line: 138,
            column: 8
          },
          end: {
            line: 138,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 138,
            column: 8
          },
          end: {
            line: 138,
            column: 26
          }
        }, {
          start: {
            line: 138,
            column: 30
          },
          end: {
            line: 138,
            column: 43
          }
        }],
        line: 138
      },
      "15": {
        loc: {
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 141,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 141,
            column: 43
          }
        }, {
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 141,
            column: 43
          }
        }],
        line: 141
      },
      "16": {
        loc: {
          start: {
            line: 144,
            column: 15
          },
          end: {
            line: 144,
            column: 50
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 144,
            column: 37
          },
          end: {
            line: 144,
            column: 41
          }
        }, {
          start: {
            line: 144,
            column: 44
          },
          end: {
            line: 144,
            column: 50
          }
        }],
        line: 144
      },
      "17": {
        loc: {
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 147,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 147,
            column: 5
          }
        }, {
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 147,
            column: 5
          }
        }],
        line: 145
      },
      "18": {
        loc: {
          start: {
            line: 145,
            column: 8
          },
          end: {
            line: 145,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 145,
            column: 8
          },
          end: {
            line: 145,
            column: 19
          }
        }, {
          start: {
            line: 145,
            column: 23
          },
          end: {
            line: 145,
            column: 39
          }
        }],
        line: 145
      },
      "19": {
        loc: {
          start: {
            line: 150,
            column: 6
          },
          end: {
            line: 150,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 150,
            column: 6
          },
          end: {
            line: 150,
            column: 32
          }
        }, {
          start: {
            line: 150,
            column: 6
          },
          end: {
            line: 150,
            column: 32
          }
        }],
        line: 150
      },
      "20": {
        loc: {
          start: {
            line: 151,
            column: 6
          },
          end: {
            line: 151,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 151,
            column: 6
          },
          end: {
            line: 151,
            column: 46
          }
        }, {
          start: {
            line: 151,
            column: 6
          },
          end: {
            line: 151,
            column: 46
          }
        }],
        line: 151
      },
      "21": {
        loc: {
          start: {
            line: 158,
            column: 6
          },
          end: {
            line: 158,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 158,
            column: 6
          },
          end: {
            line: 158,
            column: 41
          }
        }, {
          start: {
            line: 158,
            column: 6
          },
          end: {
            line: 158,
            column: 41
          }
        }],
        line: 158
      },
      "22": {
        loc: {
          start: {
            line: 161,
            column: 22
          },
          end: {
            line: 161,
            column: 87
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 161,
            column: 32
          },
          end: {
            line: 161,
            column: 58
          }
        }, {
          start: {
            line: 161,
            column: 61
          },
          end: {
            line: 161,
            column: 87
          }
        }],
        line: 161
      },
      "23": {
        loc: {
          start: {
            line: 171,
            column: 4
          },
          end: {
            line: 176,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 171,
            column: 4
          },
          end: {
            line: 176,
            column: 5
          }
        }, {
          start: {
            line: 171,
            column: 4
          },
          end: {
            line: 176,
            column: 5
          }
        }],
        line: 171
      },
      "24": {
        loc: {
          start: {
            line: 173,
            column: 8
          },
          end: {
            line: 173,
            column: 61
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 173,
            column: 8
          },
          end: {
            line: 173,
            column: 61
          }
        }, {
          start: {
            line: 173,
            column: 8
          },
          end: {
            line: 173,
            column: 61
          }
        }],
        line: 173
      },
      "25": {
        loc: {
          start: {
            line: 181,
            column: 4
          },
          end: {
            line: 186,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 181,
            column: 4
          },
          end: {
            line: 186,
            column: 5
          }
        }, {
          start: {
            line: 181,
            column: 4
          },
          end: {
            line: 186,
            column: 5
          }
        }],
        line: 181
      },
      "26": {
        loc: {
          start: {
            line: 183,
            column: 8
          },
          end: {
            line: 183,
            column: 59
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 183,
            column: 8
          },
          end: {
            line: 183,
            column: 59
          }
        }, {
          start: {
            line: 183,
            column: 8
          },
          end: {
            line: 183,
            column: 59
          }
        }],
        line: 183
      },
      "27": {
        loc: {
          start: {
            line: 196,
            column: 4
          },
          end: {
            line: 196,
            column: 22
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 196,
            column: 4
          },
          end: {
            line: 196,
            column: 22
          }
        }, {
          start: {
            line: 196,
            column: 4
          },
          end: {
            line: 196,
            column: 22
          }
        }],
        line: 196
      },
      "28": {
        loc: {
          start: {
            line: 201,
            column: 4
          },
          end: {
            line: 211,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 202,
            column: 6
          },
          end: {
            line: 204,
            column: 13
          }
        }, {
          start: {
            line: 205,
            column: 6
          },
          end: {
            line: 207,
            column: 13
          }
        }, {
          start: {
            line: 208,
            column: 6
          },
          end: {
            line: 210,
            column: 13
          }
        }],
        line: 201
      },
      "29": {
        loc: {
          start: {
            line: 219,
            column: 4
          },
          end: {
            line: 219,
            column: 53
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 219,
            column: 4
          },
          end: {
            line: 219,
            column: 53
          }
        }, {
          start: {
            line: 219,
            column: 4
          },
          end: {
            line: 219,
            column: 53
          }
        }],
        line: 219
      },
      "30": {
        loc: {
          start: {
            line: 219,
            column: 8
          },
          end: {
            line: 219,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 219,
            column: 8
          },
          end: {
            line: 219,
            column: 27
          }
        }, {
          start: {
            line: 219,
            column: 31
          },
          end: {
            line: 219,
            column: 45
          }
        }],
        line: 219
      },
      "31": {
        loc: {
          start: {
            line: 221,
            column: 20
          },
          end: {
            line: 221,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 221,
            column: 43
          },
          end: {
            line: 221,
            column: 48
          }
        }, {
          start: {
            line: 221,
            column: 51
          },
          end: {
            line: 221,
            column: 58
          }
        }],
        line: 221
      },
      "32": {
        loc: {
          start: {
            line: 222,
            column: 4
          },
          end: {
            line: 224,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 222,
            column: 4
          },
          end: {
            line: 224,
            column: 5
          }
        }, {
          start: {
            line: 222,
            column: 4
          },
          end: {
            line: 224,
            column: 5
          }
        }],
        line: 222
      },
      "33": {
        loc: {
          start: {
            line: 228,
            column: 4
          },
          end: {
            line: 254,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 228,
            column: 4
          },
          end: {
            line: 254,
            column: 5
          }
        }, {
          start: {
            line: 228,
            column: 4
          },
          end: {
            line: 254,
            column: 5
          }
        }],
        line: 228
      },
      "34": {
        loc: {
          start: {
            line: 231,
            column: 8
          },
          end: {
            line: 235,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 231,
            column: 8
          },
          end: {
            line: 235,
            column: 9
          }
        }, {
          start: {
            line: 231,
            column: 8
          },
          end: {
            line: 235,
            column: 9
          }
        }],
        line: 231
      },
      "35": {
        loc: {
          start: {
            line: 239,
            column: 8
          },
          end: {
            line: 241,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 239,
            column: 8
          },
          end: {
            line: 241,
            column: 9
          }
        }, {
          start: {
            line: 239,
            column: 8
          },
          end: {
            line: 241,
            column: 9
          }
        }],
        line: 239
      },
      "36": {
        loc: {
          start: {
            line: 247,
            column: 10
          },
          end: {
            line: 250,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 247,
            column: 10
          },
          end: {
            line: 250,
            column: 11
          }
        }, {
          start: {
            line: 247,
            column: 10
          },
          end: {
            line: 250,
            column: 11
          }
        }],
        line: 247
      },
      "37": {
        loc: {
          start: {
            line: 247,
            column: 14
          },
          end: {
            line: 247,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 247,
            column: 15
          },
          end: {
            line: 247,
            column: 43
          }
        }, {
          start: {
            line: 247,
            column: 47
          },
          end: {
            line: 247,
            column: 68
          }
        }, {
          start: {
            line: 247,
            column: 73
          },
          end: {
            line: 247,
            column: 97
          }
        }],
        line: 247
      },
      "38": {
        loc: {
          start: {
            line: 261,
            column: 4
          },
          end: {
            line: 261,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 261,
            column: 4
          },
          end: {
            line: 261,
            column: 52
          }
        }, {
          start: {
            line: 261,
            column: 4
          },
          end: {
            line: 261,
            column: 52
          }
        }],
        line: 261
      },
      "39": {
        loc: {
          start: {
            line: 263,
            column: 4
          },
          end: {
            line: 263,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 263,
            column: 4
          },
          end: {
            line: 263,
            column: 35
          }
        }, {
          start: {
            line: 263,
            column: 4
          },
          end: {
            line: 263,
            column: 35
          }
        }],
        line: 263
      },
      "40": {
        loc: {
          start: {
            line: 268,
            column: 4
          },
          end: {
            line: 268,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 268,
            column: 4
          },
          end: {
            line: 268,
            column: 35
          }
        }, {
          start: {
            line: 268,
            column: 4
          },
          end: {
            line: 268,
            column: 35
          }
        }],
        line: 268
      },
      "41": {
        loc: {
          start: {
            line: 275,
            column: 4
          },
          end: {
            line: 276,
            column: 69
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 275,
            column: 4
          },
          end: {
            line: 276,
            column: 69
          }
        }, {
          start: {
            line: 275,
            column: 4
          },
          end: {
            line: 276,
            column: 69
          }
        }],
        line: 275
      },
      "42": {
        loc: {
          start: {
            line: 276,
            column: 9
          },
          end: {
            line: 276,
            column: 69
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 276,
            column: 9
          },
          end: {
            line: 276,
            column: 69
          }
        }, {
          start: {
            line: 276,
            column: 9
          },
          end: {
            line: 276,
            column: 69
          }
        }],
        line: 276
      },
      "43": {
        loc: {
          start: {
            line: 284,
            column: 4
          },
          end: {
            line: 286,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 284,
            column: 4
          },
          end: {
            line: 286,
            column: 5
          }
        }, {
          start: {
            line: 284,
            column: 4
          },
          end: {
            line: 286,
            column: 5
          }
        }],
        line: 284
      },
      "44": {
        loc: {
          start: {
            line: 284,
            column: 8
          },
          end: {
            line: 284,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 284,
            column: 8
          },
          end: {
            line: 284,
            column: 21
          }
        }, {
          start: {
            line: 284,
            column: 25
          },
          end: {
            line: 284,
            column: 32
          }
        }],
        line: 284
      },
      "45": {
        loc: {
          start: {
            line: 292,
            column: 4
          },
          end: {
            line: 294,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 292,
            column: 4
          },
          end: {
            line: 294,
            column: 5
          }
        }, {
          start: {
            line: 292,
            column: 4
          },
          end: {
            line: 294,
            column: 5
          }
        }],
        line: 292
      },
      "46": {
        loc: {
          start: {
            line: 292,
            column: 8
          },
          end: {
            line: 292,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 292,
            column: 8
          },
          end: {
            line: 292,
            column: 24
          }
        }, {
          start: {
            line: 292,
            column: 28
          },
          end: {
            line: 292,
            column: 50
          }
        }],
        line: 292
      },
      "47": {
        loc: {
          start: {
            line: 296,
            column: 4
          },
          end: {
            line: 296,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 296,
            column: 4
          },
          end: {
            line: 296,
            column: 26
          }
        }, {
          start: {
            line: 296,
            column: 4
          },
          end: {
            line: 296,
            column: 26
          }
        }],
        line: 296
      },
      "48": {
        loc: {
          start: {
            line: 298,
            column: 4
          },
          end: {
            line: 300,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 298,
            column: 4
          },
          end: {
            line: 300,
            column: 5
          }
        }, {
          start: {
            line: 298,
            column: 4
          },
          end: {
            line: 300,
            column: 5
          }
        }],
        line: 298
      },
      "49": {
        loc: {
          start: {
            line: 302,
            column: 4
          },
          end: {
            line: 309,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 302,
            column: 4
          },
          end: {
            line: 309,
            column: 5
          }
        }, {
          start: {
            line: 302,
            column: 4
          },
          end: {
            line: 309,
            column: 5
          }
        }],
        line: 302
      },
      "50": {
        loc: {
          start: {
            line: 303,
            column: 6
          },
          end: {
            line: 305,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 303,
            column: 6
          },
          end: {
            line: 305,
            column: 7
          }
        }, {
          start: {
            line: 303,
            column: 6
          },
          end: {
            line: 305,
            column: 7
          }
        }],
        line: 303
      },
      "51": {
        loc: {
          start: {
            line: 315,
            column: 11
          },
          end: {
            line: 315,
            column: 51
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 315,
            column: 27
          },
          end: {
            line: 315,
            column: 51
          }
        }],
        line: 315
      },
      "52": {
        loc: {
          start: {
            line: 316,
            column: 4
          },
          end: {
            line: 316,
            column: 47
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 316,
            column: 4
          },
          end: {
            line: 316,
            column: 47
          }
        }, {
          start: {
            line: 316,
            column: 4
          },
          end: {
            line: 316,
            column: 47
          }
        }],
        line: 316
      },
      "53": {
        loc: {
          start: {
            line: 317,
            column: 4
          },
          end: {
            line: 322,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 317,
            column: 4
          },
          end: {
            line: 322,
            column: 5
          }
        }, {
          start: {
            line: 317,
            column: 4
          },
          end: {
            line: 322,
            column: 5
          }
        }],
        line: 317
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0,
      "160": 0,
      "161": 0,
      "162": 0,
      "163": 0,
      "164": 0,
      "165": 0,
      "166": 0,
      "167": 0,
      "168": 0,
      "169": 0,
      "170": 0,
      "171": 0,
      "172": 0,
      "173": 0,
      "174": 0,
      "175": 0,
      "176": 0,
      "177": 0,
      "178": 0,
      "179": 0,
      "180": 0,
      "181": 0,
      "182": 0,
      "183": 0,
      "184": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0],
      "52": [0, 0],
      "53": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import deepEqual from 'deep-eql';
import shallowEqual from '../utils/shallowEqual';
import { CHANGE_TOPIC, WITH_OUT_DISPATCH } from './types';

var _default =
/*#__PURE__*/
function () {
  function _default() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_3nd4b0rs3.b[0][0]++, {});

    _classCallCheck(this, _default);

    this.distinct = void 0;
    this.prediction = void 0;
    this.onChange = void 0;
    this.limit = void 0;
    this.separator = void 0;
    this.$events = void 0;
    this.$cachedDisabled = void 0;
    this.$cachedFlatten = void 0;
    this.valueMap = void 0;
    this.disabled = void 0;
    this.format = void 0;
    this.$values = void 0;
    this.$cachedValue = void 0;
    this.updateLock = void 0;
    cov_3nd4b0rs3.f[0]++;

    var _ref = (cov_3nd4b0rs3.s[0]++, args),
        format = _ref.format,
        onChange = _ref.onChange,
        separator = _ref.separator,
        value = _ref.value,
        prediction = _ref.prediction,
        distinct = _ref.distinct,
        disabled = _ref.disabled,
        limit = _ref.limit;

    cov_3nd4b0rs3.s[1]++;
    this.distinct = distinct;
    cov_3nd4b0rs3.s[2]++;
    this.limit = limit;
    cov_3nd4b0rs3.s[3]++;
    this.separator = separator;
    cov_3nd4b0rs3.s[4]++;
    this.initFormat(format);
    cov_3nd4b0rs3.s[5]++;
    this.$events = {};
    cov_3nd4b0rs3.s[6]++;
    this.$cachedDisabled = {};
    cov_3nd4b0rs3.s[7]++;
    this.$cachedFlatten = new Map();
    cov_3nd4b0rs3.s[8]++;
    this.setDisabled(disabled);
    cov_3nd4b0rs3.s[9]++;

    if (prediction) {
      cov_3nd4b0rs3.b[1][0]++;
      cov_3nd4b0rs3.s[10]++;
      this.prediction = prediction;
    } else {
      cov_3nd4b0rs3.b[1][1]++;
    }

    cov_3nd4b0rs3.s[11]++;
    this.setValue(value, WITH_OUT_DISPATCH);
    cov_3nd4b0rs3.s[12]++;
    this.onChange = onChange;
  }

  _createClass(_default, [{
    key: "cleanDataCache",
    // should clean $cachedFlatten when data changed
    value: function cleanDataCache() {
      cov_3nd4b0rs3.f[2]++;
      cov_3nd4b0rs3.s[14]++;
      this.$cachedFlatten = new Map();
    }
  }, {
    key: "resetValueMap",
    value: function resetValueMap() {
      cov_3nd4b0rs3.f[5]++;
      var map = (cov_3nd4b0rs3.s[21]++, new Map());
      cov_3nd4b0rs3.s[22]++;

      for (var i = 0; i < this.$values.length; i++) {
        cov_3nd4b0rs3.s[23]++;
        map.set(this.$values[i], true);
      }

      cov_3nd4b0rs3.s[24]++;
      this.valueMap = map;
    }
  }, {
    key: "setDisabled",
    value: function setDisabled(disabled) {
      cov_3nd4b0rs3.f[6]++;
      cov_3nd4b0rs3.s[25]++;

      if (this.$cachedDisabled === disabled) {
        cov_3nd4b0rs3.b[3][0]++;
        cov_3nd4b0rs3.s[26]++;
        return;
      } else {
        cov_3nd4b0rs3.b[3][1]++;
      }

      cov_3nd4b0rs3.s[27]++;
      this.$cachedDisabled = disabled;
      cov_3nd4b0rs3.s[28]++;

      this.disabled = function (data) {
        cov_3nd4b0rs3.f[7]++;
        cov_3nd4b0rs3.s[29]++;

        switch (typeof disabled) {
          case 'boolean':
            cov_3nd4b0rs3.b[4][0]++;
            cov_3nd4b0rs3.s[30]++;
            return disabled;

          case 'function':
            cov_3nd4b0rs3.b[4][1]++;
            cov_3nd4b0rs3.s[31]++;

            for (var _len = arguments.length, obj = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              obj[_key - 1] = arguments[_key];
            }

            return disabled.apply(void 0, [data].concat(obj));

          default:
            cov_3nd4b0rs3.b[4][2]++;
            cov_3nd4b0rs3.s[32]++;
            return false;
        }
      };
    }
  }, {
    key: "handleChange",
    value: function handleChange(values) {
      cov_3nd4b0rs3.f[8]++;
      cov_3nd4b0rs3.s[33]++;
      this.$values = values;
      cov_3nd4b0rs3.s[34]++;
      this.resetValueMap();
      cov_3nd4b0rs3.s[35]++;
      this.dispatch(CHANGE_TOPIC);
      cov_3nd4b0rs3.s[36]++;

      if (this.onChange) {
        cov_3nd4b0rs3.b[5][0]++;
        cov_3nd4b0rs3.s[37]++;

        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        this.onChange.apply(this, [this.getValue()].concat(args));
      } else {
        cov_3nd4b0rs3.b[5][1]++;
      }
    }
  }, {
    key: "flattenTreeData",
    value: function flattenTreeData(data, childrenKey) {
      var _this = this;

      cov_3nd4b0rs3.f[9]++;
      var keys = (cov_3nd4b0rs3.s[38]++, data.map(function (v) {
        cov_3nd4b0rs3.f[10]++;
        cov_3nd4b0rs3.s[39]++;
        return _this.format(v);
      }).map(function (v) {
        cov_3nd4b0rs3.f[11]++;
        cov_3nd4b0rs3.s[40]++;
        return typeof v === 'object' ? (cov_3nd4b0rs3.b[6][0]++, JSON.stringify(v)) : (cov_3nd4b0rs3.b[6][1]++, v);
      }));
      var key = (cov_3nd4b0rs3.s[41]++, keys.join());
      cov_3nd4b0rs3.s[42]++;

      if (keys.length !== 0) {
        cov_3nd4b0rs3.b[7][0]++;
        var cached = (cov_3nd4b0rs3.s[43]++, this.$cachedFlatten.get(key));
        cov_3nd4b0rs3.s[44]++;

        if (cached) {
          cov_3nd4b0rs3.b[8][0]++;
          cov_3nd4b0rs3.s[45]++;
          return cached;
        } else {
          cov_3nd4b0rs3.b[8][1]++;
        }
      } else {
        cov_3nd4b0rs3.b[7][1]++;
      }

      var flatten = (cov_3nd4b0rs3.s[46]++, []);
      cov_3nd4b0rs3.s[47]++;

      var deepAdd = function deepAdd(items) {
        cov_3nd4b0rs3.f[12]++;
        cov_3nd4b0rs3.s[48]++;
        items.forEach(function (item) {
          cov_3nd4b0rs3.f[13]++;
          var exist = (cov_3nd4b0rs3.s[49]++, flatten.find(function (raw) {
            cov_3nd4b0rs3.f[14]++;
            cov_3nd4b0rs3.s[50]++;
            return _this.prediction ? (cov_3nd4b0rs3.b[9][0]++, _this.prediction(raw, item)) : (cov_3nd4b0rs3.b[9][1]++, _this.format(raw) === _this.format(item));
          }));
          cov_3nd4b0rs3.s[51]++;

          if (!exist) {
            cov_3nd4b0rs3.b[10][0]++;
            cov_3nd4b0rs3.s[52]++;
            flatten.push(item);
          } else {
            cov_3nd4b0rs3.b[10][1]++;
          }

          cov_3nd4b0rs3.s[53]++;

          if (item[childrenKey]) {
            cov_3nd4b0rs3.b[11][0]++;
            cov_3nd4b0rs3.s[54]++;
            deepAdd(item[childrenKey]);
          } else {
            cov_3nd4b0rs3.b[11][1]++;
          }
        });
      };

      cov_3nd4b0rs3.s[55]++;
      deepAdd(data);
      cov_3nd4b0rs3.s[56]++;

      if (keys.length) {
        cov_3nd4b0rs3.b[12][0]++;
        cov_3nd4b0rs3.s[57]++;
        this.$cachedFlatten.set(key, flatten);
      } else {
        cov_3nd4b0rs3.b[12][1]++;
      }

      cov_3nd4b0rs3.s[58]++;
      return flatten;
    }
  }, {
    key: "setLock",
    value: function setLock(lock) {
      cov_3nd4b0rs3.f[15]++;
      cov_3nd4b0rs3.s[59]++;
      this.updateLock = lock;
    }
  }, {
    key: "add",
    value: function add(data, _, childrenKey, unshift) {
      var _this2 = this;

      cov_3nd4b0rs3.f[16]++;
      cov_3nd4b0rs3.s[60]++;

      if ((cov_3nd4b0rs3.b[14][0]++, data === undefined) || (cov_3nd4b0rs3.b[14][1]++, data === null)) {
        cov_3nd4b0rs3.b[13][0]++;
        cov_3nd4b0rs3.s[61]++;
        return;
      } else {
        cov_3nd4b0rs3.b[13][1]++;
      } // clear value


      cov_3nd4b0rs3.s[62]++;

      if (this.limit === 1) {
        cov_3nd4b0rs3.b[15][0]++;
        cov_3nd4b0rs3.s[63]++;
        this.$values = [];
      } else {
        cov_3nd4b0rs3.b[15][1]++;
      }

      cov_3nd4b0rs3.s[64]++;
      this.resetValueMap();
      var raws = (cov_3nd4b0rs3.s[65]++, Array.isArray(data) ? (cov_3nd4b0rs3.b[16][0]++, data) : (cov_3nd4b0rs3.b[16][1]++, [data]));
      cov_3nd4b0rs3.s[66]++;

      if ((cov_3nd4b0rs3.b[18][0]++, childrenKey) && (cov_3nd4b0rs3.b[18][1]++, this.limit !== 1)) {
        cov_3nd4b0rs3.b[17][0]++;
        cov_3nd4b0rs3.s[67]++;
        raws = this.flattenTreeData(raws, childrenKey);
      } else {
        cov_3nd4b0rs3.b[17][1]++;
      }

      cov_3nd4b0rs3.s[68]++;
      raws = raws.filter(function (v) {
        cov_3nd4b0rs3.f[17]++;
        var disabled = (cov_3nd4b0rs3.s[69]++, _this2.disabled(v));
        cov_3nd4b0rs3.s[70]++;

        if (disabled) {
          cov_3nd4b0rs3.b[19][0]++;
          cov_3nd4b0rs3.s[71]++;
          return false;
        } else {
          cov_3nd4b0rs3.b[19][1]++;
        }

        cov_3nd4b0rs3.s[72]++;

        if (_this2.distinct) {
          cov_3nd4b0rs3.b[20][0]++;
          cov_3nd4b0rs3.s[73]++;
          return !_this2.check(v);
        } else {
          cov_3nd4b0rs3.b[20][1]++;
        }

        cov_3nd4b0rs3.s[74]++;
        return true;
      });
      var values = (cov_3nd4b0rs3.s[75]++, []);
      cov_3nd4b0rs3.s[76]++;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = raws[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var r = _step.value;
          var v = (cov_3nd4b0rs3.s[77]++, this.format(r));
          cov_3nd4b0rs3.s[78]++;

          if (v !== undefined) {
            cov_3nd4b0rs3.b[21][0]++;
            cov_3nd4b0rs3.s[79]++;
            values.push(v);
          } else {
            cov_3nd4b0rs3.b[21][1]++;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      cov_3nd4b0rs3.s[80]++;
      this.handleChange(unshift ? (cov_3nd4b0rs3.b[22][0]++, values.concat(this.values)) : (cov_3nd4b0rs3.b[22][1]++, this.values.concat(values)), data, true);
    }
  }, {
    key: "set",
    value: function set(value) {
      cov_3nd4b0rs3.f[18]++;
      cov_3nd4b0rs3.s[81]++;
      this.$values = [];
      cov_3nd4b0rs3.s[82]++;
      this.resetValueMap();
      cov_3nd4b0rs3.s[83]++;
      this.add(value);
    }
  }, {
    key: "check",
    value: function check(raw) {
      cov_3nd4b0rs3.f[19]++;
      cov_3nd4b0rs3.s[84]++;

      if (this.prediction) {
        cov_3nd4b0rs3.b[23][0]++;
        cov_3nd4b0rs3.s[85]++;

        for (var i = 0, count = this.values.length; i < count; i++) {
          cov_3nd4b0rs3.s[86]++;

          if (this.prediction(this.values[i], raw)) {
            cov_3nd4b0rs3.b[24][0]++;
            cov_3nd4b0rs3.s[87]++;
            return true;
          } else {
            cov_3nd4b0rs3.b[24][1]++;
          }
        }

        cov_3nd4b0rs3.s[88]++;
        return false;
      } else {
        cov_3nd4b0rs3.b[23][1]++;
      }

      cov_3nd4b0rs3.s[89]++;
      return !!this.valueMap.get(this.format(raw));
    }
  }, {
    key: "getDataByValue",
    value: function getDataByValue(data, value) {
      var _this3 = this;

      cov_3nd4b0rs3.f[20]++;
      cov_3nd4b0rs3.s[90]++;

      if (this.prediction) {
        cov_3nd4b0rs3.b[25][0]++;
        cov_3nd4b0rs3.s[91]++;

        for (var i = 0, count = data.length; i < count; i++) {
          cov_3nd4b0rs3.s[92]++;

          if (this.prediction(value, data[i])) {
            cov_3nd4b0rs3.b[26][0]++;
            cov_3nd4b0rs3.s[93]++;
            return data[i];
          } else {
            cov_3nd4b0rs3.b[26][1]++;
          }
        }

        cov_3nd4b0rs3.s[94]++;
        return null;
      } else {
        cov_3nd4b0rs3.b[25][1]++;
      }

      cov_3nd4b0rs3.s[95]++;
      return data.find(function (d) {
        cov_3nd4b0rs3.f[21]++;
        cov_3nd4b0rs3.s[96]++;
        return value === _this3.format(d);
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      cov_3nd4b0rs3.f[22]++;
      cov_3nd4b0rs3.s[97]++;
      this.values = [];
    }
  }, {
    key: "dispatch",
    value: function dispatch(name) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      cov_3nd4b0rs3.f[23]++;
      var event = (cov_3nd4b0rs3.s[98]++, this.$events[name]);
      cov_3nd4b0rs3.s[99]++;

      if (!event) {
        cov_3nd4b0rs3.b[27][0]++;
        cov_3nd4b0rs3.s[100]++;
        return;
      } else {
        cov_3nd4b0rs3.b[27][1]++;
      }

      cov_3nd4b0rs3.s[101]++;
      event.forEach(function (fn) {
        cov_3nd4b0rs3.f[24]++;
        cov_3nd4b0rs3.s[102]++;
        return fn.apply(void 0, args);
      });
    }
  }, {
    key: "initFormat",
    value: function initFormat(f) {
      cov_3nd4b0rs3.f[25]++;
      cov_3nd4b0rs3.s[103]++;

      switch (typeof f) {
        case 'string':
          cov_3nd4b0rs3.b[28][0]++;
          cov_3nd4b0rs3.s[104]++;

          this.format = function (value) {
            cov_3nd4b0rs3.f[26]++;
            cov_3nd4b0rs3.s[105]++;
            return value[f];
          };

          cov_3nd4b0rs3.s[106]++;
          break;

        case 'function':
          cov_3nd4b0rs3.b[28][1]++;
          cov_3nd4b0rs3.s[107]++;

          this.format = function (value) {
            cov_3nd4b0rs3.f[27]++;
            cov_3nd4b0rs3.s[108]++;
            return f(value);
          };

          cov_3nd4b0rs3.s[109]++;
          break;

        default:
          cov_3nd4b0rs3.b[28][2]++;
          cov_3nd4b0rs3.s[110]++;

          this.format = function (a) {
            cov_3nd4b0rs3.f[28]++;
            cov_3nd4b0rs3.s[111]++;
            return a;
          };

          cov_3nd4b0rs3.s[112]++;
          break;
      }
    }
  }, {
    key: "defaultPrediction",
    value: function defaultPrediction(value, data) {
      cov_3nd4b0rs3.f[29]++;
      cov_3nd4b0rs3.s[113]++;
      return value === this.format(data);
    }
  }, {
    key: "remove",
    value: function remove(value, _, childrenKey) {
      var _this4 = this;

      cov_3nd4b0rs3.f[30]++;
      cov_3nd4b0rs3.s[114]++;

      if ((cov_3nd4b0rs3.b[30][0]++, value === undefined) || (cov_3nd4b0rs3.b[30][1]++, value === null)) {
        cov_3nd4b0rs3.b[29][0]++;
        cov_3nd4b0rs3.s[115]++;
        return;
      } else {
        cov_3nd4b0rs3.b[29][1]++;
      }

      var raws = (cov_3nd4b0rs3.s[116]++, Array.isArray(value) ? (cov_3nd4b0rs3.b[31][0]++, value) : (cov_3nd4b0rs3.b[31][1]++, [value]));
      cov_3nd4b0rs3.s[117]++;

      if (childrenKey) {
        cov_3nd4b0rs3.b[32][0]++;
        cov_3nd4b0rs3.s[118]++;
        raws = this.flattenTreeData(raws, childrenKey);
      } else {
        cov_3nd4b0rs3.b[32][1]++;
      }

      cov_3nd4b0rs3.s[119]++;
      raws = raws.filter(function (r) {
        cov_3nd4b0rs3.f[31]++;
        cov_3nd4b0rs3.s[120]++;
        return !_this4.disabled(r);
      });
      var values = (cov_3nd4b0rs3.s[121]++, []);
      cov_3nd4b0rs3.s[122]++;

      if (!this.prediction) {
        cov_3nd4b0rs3.b[33][0]++;
        var rowValueMap = (cov_3nd4b0rs3.s[123]++, new Map());
        cov_3nd4b0rs3.s[124]++;

        for (var i = 0; i < raws.length; i++) {
          cov_3nd4b0rs3.s[125]++;

          if (raws[i].IS_NOT_MATCHED_VALUE) {
            cov_3nd4b0rs3.b[34][0]++;
            cov_3nd4b0rs3.s[126]++;
            rowValueMap.set(raws[i].value, true);
          } else {
            cov_3nd4b0rs3.b[34][1]++;
            cov_3nd4b0rs3.s[127]++;
            rowValueMap.set(this.format(raws[i]), true);
          }
        }

        cov_3nd4b0rs3.s[128]++;

        for (var _i = 0; _i < this.values.length; _i++) {
          var val = (cov_3nd4b0rs3.s[129]++, this.values[_i]);
          cov_3nd4b0rs3.s[130]++;

          if (!rowValueMap.get(val)) {
            cov_3nd4b0rs3.b[35][0]++;
            cov_3nd4b0rs3.s[131]++;
            values.push(val);
          } else {
            cov_3nd4b0rs3.b[35][1]++;
          }
        }
      } else {
        cov_3nd4b0rs3.b[33][1]++;

        var _ref2 = (cov_3nd4b0rs3.s[132]++, this),
            prediction = _ref2.prediction;

        cov_3nd4b0rs3.s[133]++;
        cov_3nd4b0rs3.s[134]++;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          outer: for (var _iterator2 = this.values[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _val = _step2.value;
            cov_3nd4b0rs3.s[135]++;

            for (var j = 0; j < raws.length; j++) {
              cov_3nd4b0rs3.s[136]++;

              if ((cov_3nd4b0rs3.b[37][0]++, raws[j].IS_NOT_MATCHED_VALUE) && (cov_3nd4b0rs3.b[37][1]++, _val === raws[j].value) || (cov_3nd4b0rs3.b[37][2]++, prediction(_val, raws[j]))) {
                cov_3nd4b0rs3.b[36][0]++;
                cov_3nd4b0rs3.s[137]++;
                raws.splice(j, 1);
                cov_3nd4b0rs3.s[138]++;
                continue outer;
              } else {
                cov_3nd4b0rs3.b[36][1]++;
              }
            }

            cov_3nd4b0rs3.s[139]++;
            values.push(_val);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
              _iterator2["return"]();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      } // this.values = values


      cov_3nd4b0rs3.s[140]++;
      this.handleChange(values, value, false);
    }
  }, {
    key: "subscribe",
    value: function subscribe(name, fn) {
      cov_3nd4b0rs3.f[32]++;
      cov_3nd4b0rs3.s[141]++;

      if (!this.$events[name]) {
        cov_3nd4b0rs3.b[38][0]++;
        cov_3nd4b0rs3.s[142]++;
        this.$events[name] = [];
      } else {
        cov_3nd4b0rs3.b[38][1]++;
      }

      var events = (cov_3nd4b0rs3.s[143]++, this.$events[name]);
      cov_3nd4b0rs3.s[144]++;

      if (events.includes(fn)) {
        cov_3nd4b0rs3.b[39][0]++;
        cov_3nd4b0rs3.s[145]++;
        return;
      } else {
        cov_3nd4b0rs3.b[39][1]++;
      }

      cov_3nd4b0rs3.s[146]++;
      events.push(fn);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(name, fn) {
      cov_3nd4b0rs3.f[33]++;
      cov_3nd4b0rs3.s[147]++;

      if (!this.$events[name]) {
        cov_3nd4b0rs3.b[40][0]++;
        cov_3nd4b0rs3.s[148]++;
        return;
      } else {
        cov_3nd4b0rs3.b[40][1]++;
      }

      cov_3nd4b0rs3.s[149]++;
      this.$events[name] = this.$events[name].filter(function (e) {
        cov_3nd4b0rs3.f[34]++;
        cov_3nd4b0rs3.s[150]++;
        return e !== fn;
      });
    }
  }, {
    key: "getValue",
    value: function getValue() {
      cov_3nd4b0rs3.f[35]++;
      var value = (cov_3nd4b0rs3.s[151]++, this.values); // eslint-disable-next-line

      cov_3nd4b0rs3.s[152]++;

      if (this.limit === 1) {
        cov_3nd4b0rs3.b[41][0]++;
        cov_3nd4b0rs3.s[153]++;
        value = this.values[0];
      } else {
        cov_3nd4b0rs3.b[41][1]++;
        cov_3nd4b0rs3.s[154]++;

        if (this.separator) {
          cov_3nd4b0rs3.b[42][0]++;
          cov_3nd4b0rs3.s[155]++;
          value = this.values.join(this.separator);
        } else {
          cov_3nd4b0rs3.b[42][1]++;
        }
      }

      cov_3nd4b0rs3.s[156]++;
      this.$cachedValue = value;
      cov_3nd4b0rs3.s[157]++;
      return value;
    }
  }, {
    key: "resetValue",
    value: function resetValue(values, cached) {
      cov_3nd4b0rs3.f[36]++;
      cov_3nd4b0rs3.s[158]++;
      this.$values = values;
      cov_3nd4b0rs3.s[159]++;
      this.resetValueMap();
      cov_3nd4b0rs3.s[160]++;

      if ((cov_3nd4b0rs3.b[44][0]++, this.onChange) && (cov_3nd4b0rs3.b[44][1]++, !cached)) {
        cov_3nd4b0rs3.b[43][0]++;
        cov_3nd4b0rs3.s[161]++;
        this.onChange(this.getValue());
      } else {
        cov_3nd4b0rs3.b[43][1]++;
      }

      cov_3nd4b0rs3.s[162]++;
      this.dispatch(CHANGE_TOPIC);
      cov_3nd4b0rs3.s[163]++;
      this.dispatch('set-value');
    }
  }, {
    key: "formatValue",
    value: function formatValue(values) {
      cov_3nd4b0rs3.f[37]++;
      cov_3nd4b0rs3.s[164]++;

      if ((cov_3nd4b0rs3.b[46][0]++, this.limit === 1) && (cov_3nd4b0rs3.b[46][1]++, !Array.isArray(values))) {
        cov_3nd4b0rs3.b[45][0]++;
        cov_3nd4b0rs3.s[165]++;
        return [values];
      } else {
        cov_3nd4b0rs3.b[45][1]++;
      }

      cov_3nd4b0rs3.s[166]++;

      if (!values) {
        cov_3nd4b0rs3.b[47][0]++;
        cov_3nd4b0rs3.s[167]++;
        return [];
      } else {
        cov_3nd4b0rs3.b[47][1]++;
      }

      cov_3nd4b0rs3.s[168]++;

      if (Array.isArray(values)) {
        cov_3nd4b0rs3.b[48][0]++;
        cov_3nd4b0rs3.s[169]++;
        return values;
      } else {
        cov_3nd4b0rs3.b[48][1]++;
      }

      cov_3nd4b0rs3.s[170]++;

      if (typeof values === 'string') {
        cov_3nd4b0rs3.b[49][0]++;
        cov_3nd4b0rs3.s[171]++;

        if (this.separator) {
          cov_3nd4b0rs3.b[50][0]++;
          cov_3nd4b0rs3.s[172]++;
          return values.split(this.separator).map(function (s) {
            cov_3nd4b0rs3.f[38]++;
            cov_3nd4b0rs3.s[173]++;
            return s.trim();
          });
        } else {
          cov_3nd4b0rs3.b[50][1]++;
        }

        cov_3nd4b0rs3.s[174]++;
        console.warn('Select separator parameter is empty.');
        cov_3nd4b0rs3.s[175]++;
        return [values];
      } else {
        cov_3nd4b0rs3.b[49][1]++;
      }

      cov_3nd4b0rs3.s[176]++;
      console.error(new Error('Select values is not valid.'));
      cov_3nd4b0rs3.s[177]++;
      return [];
    }
  }, {
    key: "setValue",
    value: function setValue() {
      var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_3nd4b0rs3.b[51][0]++, []);
      var type = arguments.length > 1 ? arguments[1] : undefined;
      cov_3nd4b0rs3.f[39]++;
      cov_3nd4b0rs3.s[178]++;

      if (deepEqual(values, this.$values)) {
        cov_3nd4b0rs3.b[52][0]++;
        cov_3nd4b0rs3.s[179]++;
        return;
      } else {
        cov_3nd4b0rs3.b[52][1]++;
      }

      cov_3nd4b0rs3.s[180]++;

      if (type === WITH_OUT_DISPATCH) {
        cov_3nd4b0rs3.b[53][0]++;
        cov_3nd4b0rs3.s[181]++;
        this.$values = this.formatValue(values);
        cov_3nd4b0rs3.s[182]++;
        this.resetValueMap();
      } else {
        cov_3nd4b0rs3.b[53][1]++;
        cov_3nd4b0rs3.s[183]++;
        this.resetValue(this.formatValue(values), shallowEqual(this.$cachedValue, values, {}));
      }

      cov_3nd4b0rs3.s[184]++;
      this.$cachedValue = this.getValue();
    }
  }, {
    key: "length",
    get: function get() {
      cov_3nd4b0rs3.f[1]++;
      cov_3nd4b0rs3.s[13]++;
      return this.$values.length;
    }
  }, {
    key: "values",
    get: function get() {
      cov_3nd4b0rs3.f[3]++;
      cov_3nd4b0rs3.s[15]++;
      return this.$values;
    },
    set: function set(values) {
      cov_3nd4b0rs3.f[4]++;
      cov_3nd4b0rs3.s[16]++;
      this.$values = values;
      cov_3nd4b0rs3.s[17]++;
      this.resetValueMap();
      cov_3nd4b0rs3.s[18]++;
      this.dispatch(CHANGE_TOPIC);
      cov_3nd4b0rs3.s[19]++;

      if (this.onChange) {
        cov_3nd4b0rs3.b[2][0]++;
        cov_3nd4b0rs3.s[20]++;
        this.onChange(this.getValue());
      } else {
        cov_3nd4b0rs3.b[2][1]++;
      }
    }
  }]);

  return _default;
}();

export { _default as default };